/**
 * Bolts Roster - Custom Element Flip Logic
 * Uses event delegation for performance and stability.
 */
if (!customElements.get('roster-grid')) {
  class RosterGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Listen for clicks on the entire grid
      this.addEventListener('click', (e) => this.handleFlip(e));
      
      // Accessibility: Listen for keyboard interaction
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.code === 'Space') {
          // Prevent scrolling if Space is pressed
          if (e.code === 'Space') e.preventDefault();
          this.handleFlip(e);
        }
      });
    }

    handleFlip(event) {
      // Find the card being clicked
      const card = event.target.closest('.bolts-fo__card');
      if (!card) return;

      const inner = card.querySelector('.bolts-fo__card-inner');
      if (inner) {
        const isFlipped = inner.classList.toggle('is-flipped');
        
        // Update ARIA for screen readers
        card.setAttribute('aria-expanded', isFlipped);

        // Optional: Close other cards when one is opened
        // this.closeOtherCards(card);
      }
    }

    closeOtherCards(currentCard) {
      this.querySelectorAll('.bolts-fo__card').forEach(card => {
        if (card !== currentCard) {
          card.querySelector('.bolts-fo__card-inner').classList.remove('is-flipped');
          card.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  customElements.define('roster-grid', RosterGrid);
}